import { Box, CollapsableCard, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'
import { useToggle } from 'usehooks-ts'

import i18n from 'modules/core/lib/i18n'

import { ExpensableMileage } from 'modules/expenses/hooks/useExpensable'

import MileageStatusCardContent from './_Content'

interface Props {
  mileage: ExpensableMileage | undefined | null
}

const MileageStatusCard = ({ mileage }: Props) => {
  const [showContent, toggleContent] = useToggle(true)

  return (
    <CollapsableCard
      open={showContent}
      contentBackground="grey000White"
      contentPadding="s8"
      Card={
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Text size="300" weight="semibold" color="radicalRed1200">
            {i18n.t('expenses_v2.forms.fields.mileage.alert.manually_changed.comparison_title')}
          </Text>
          <Touchable onClick={toggleContent}>
            <Icon.Small icon={showContent ? 'chevron-up' : 'chevron-down'} color="grey800" />
          </Touchable>
        </Box>
      }
      Content={<MileageStatusCardContent mileage={mileage} />}
    />
  )
}

export default MileageStatusCard
